import { useEffect, useState } from 'react';
import { getMe } from '../services/vault/me';

export default function useMe() {
  const [user, setUser] = useState<User>();

  useEffect(() => {
    if (user) {
      return;
    }
    const getUser = async () => {
      const me = await getMe();
      setUser(me);
    };
    getUser();
  }, [user]);
  return user;
}
